import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const getParticularpblAPI = createAsyncThunk(
  "auth/pbl/getPaticular",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.get(
        apiRoutes.projectBasedAction(`${id}`, 1)
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" };
const getparticularDetailspblSlice = createSlice({
  name: "get particular pbl",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetgetparticularpbl: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getParticularpblAPI.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getParticularpblAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(getParticularpblAPI.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetgetparticularpbl } = getparticularDetailspblSlice.actions;
export const getparticularDetailspblReducer =
  getparticularDetailspblSlice.reducer;
